import { HttpClient } from '../HttpClient';
/**
 * * Patch Employees
 */
export const PatchEmployees = async (projectId, patchEmployeesData) => {
  try {
    const { data } = await HttpClient.patch(`api/projects/${projectId}/Employees`, {
      ...patchEmployeesData,
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
